import { render, staticRenderFns } from "./MateriaisExtras.vue?vue&type=template&id=0deffdc8&scoped=true"
import script from "./MateriaisExtras.vue?vue&type=script&lang=js"
export * from "./MateriaisExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deffdc8",
  null
  
)

export default component.exports